import { render, staticRenderFns } from "./platformPicker.vue?vue&type=template&id=7613d27c&scoped=true&"
import script from "./platformPicker.vue?vue&type=script&lang=js&"
export * from "./platformPicker.vue?vue&type=script&lang=js&"
import style0 from "./platformPicker.vue?vue&type=style&index=0&id=7613d27c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7613d27c",
  null
  
)

export default component.exports